import { storage } from 'index'

export const isImageExistOnDestination = async (path) => {
  try {
    const destinationRef = storage.ref(path)
    await destinationRef.getMetadata()
    return true
  } catch (err) {
    return false
  }
}

export const deleteImageFromStorageIfExist = async (path) => {
  const isImageExist = await isImageExistOnDestination(path)
  if (isImageExist) {
    await storage.ref(path).delete()
  }
}

export const copySubjectImageToSpecificPath = async (imageName, source, destination, confId) => {
  try {
    const sourcePath = `images/${source}/${imageName}`
    const sourceRef = storage.ref(sourcePath)
    const destinationRef = storage.ref(`images/${confId}/${destination}/${imageName}`)

    const isAlreadyExist = await isImageExistOnDestination(
      `images/${confId}/${destination}/${imageName}`
    )

    if (!isAlreadyExist) {
      const sourceImage = await sourceRef.getDownloadURL()
      if (sourceImage) {
        const response = await fetch(sourceImage)
        const fileBlob = await response.blob()
        await destinationRef.put(fileBlob)
      }
    }
  } catch (err) {
    console.error(err)
    // do nothing
  }
}

export const placeSpecificImageToSubjectPath = async (imageName, source, destination, confId) => {
  try {
    const sourcePath = `images/${confId}/${source}/${imageName}`
    const sourceRef = storage.ref(sourcePath)
    const destinationRef = storage.ref(`images/${destination}/${imageName}`)

    const isAlreadyExist = await isImageExistOnDestination(`images/${destination}/${imageName}`)

    if (!isAlreadyExist) {
      const sourceImage = await sourceRef.getDownloadURL()
      if (sourceImage) {
        const response = await fetch(sourceImage)
        const fileBlob = await response.blob()
        await destinationRef.put(fileBlob)
      }
    }
  } catch (err) {
    console.error(err)
  }
}

export const placeImageToDifferentPath = async (sourcePath, destinationPath) => {
  try {
    const sourceRef = storage.ref(sourcePath)
    const destinationRef = storage.ref(destinationPath)

    const sourceImage = await sourceRef.getDownloadURL()
    if (sourceImage) {
      const response = await fetch(sourceImage)
      const fileBlob = await response.blob()
      await destinationRef.put(fileBlob)
    }
  } catch (err) {
    console.error(err)
  }
}
